import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LocalLoader from "@/components/ui/loaders/LocalLoader.vue";

interface Props {
  position?: "fixed" | "absolute";
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableLoader',
  props: {
    position: { default: "fixed" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-loader", `table-loader--${props.position}`])
  }, [
    _createVNode(LocalLoader)
  ], 2))
}
}

})